import { InputItem, TextareaItem, Toast } from "antd-mobile";
import React, { forwardRef, useEffect, useState } from "react";
import { BaseURL } from "../../constant";
import DictionarySelect from "../CheckBoxItem";
import DateItem from "../DateItem";
import ImageItem from "../ImageItem";
import RadioItem from "../RadioItem";
import { Description } from "../schema";
import { Image, ImageViewer } from "antd-mobile-v5";
import { LocationOutline } from "antd-mobile-icons";
import instance from "../../util/axios";
import { Result } from "../../schema";

interface GridItemProps {
  description: Description;
  mobileTitle?: string;
  defaultValue: any;
  error: boolean;
  hidden: boolean;
  onChange: (value: any) => void;
}

export default forwardRef(
  (
    {
      description,
      mobileTitle,
      defaultValue,
      error,
      hidden,
      onChange,
    }: GridItemProps,
    ref: any
  ) => {
    const [digitError, setDigitError] = useState<boolean>(false);
    const [imageForm, setImageForm] = useState<{
      visible: boolean;
      src?: string;
    }>({
      visible: false,
    });
    const [loading, setLoading] = useState<boolean>(false);

    const mobileShowName = mobileTitle
      ? mobileTitle
      : description.fieldShowName;
    return (
      <>
        <div hidden={hidden}>
          {description.inputType === 2 ? (
            <>
              <div
                className="table-grid-item-title"
                style={
                  error || digitError
                    ? {
                        color: "red",
                      }
                    : {}
                }
                onClick={() => {
                  Toast.info("请填写" + mobileShowName, 1);
                }}
              >
                {mobileShowName}
              </div>
              <InputItem
                key={description.fieldName}
                disabled={description.readOnly}
                value={defaultValue}
                placeholder={"请填写"}
                onChange={(data) => {
                  if (/^[+-]?[0-9.]+$/.test(data)) setDigitError(false);
                  else {
                    setDigitError(true);
                    Toast.info("请填写数字格式", 1);
                  }
                  if (data !== undefined) onChange(data);
                }}
              />
            </>
          ) : description.inputType === 4 ? (
            <DateItem
              key={description.fieldName}
              disabled={description.readOnly}
              required={description.required}
              dictionary={description.dictionary!}
              value={defaultValue?.split(",")}
              placeholder={"请选择"}
              onChange={(data) => {
                if (data !== undefined) onChange(data);
              }}
            >
              <div
                className="table-grid-item-date-title"
                style={error ? { color: "red" } : {}}
                onClick={() => {
                  Toast.info("请填写" + mobileShowName, 1);
                }}
              >
                {mobileShowName}
              </div>
            </DateItem>
          ) : description.inputType === 6 ? (
            <RadioItem
              key={description.fieldName}
              disabled={description.readOnly}
              dictionary={description.dictionary!}
              value={defaultValue}
              required={description.required}
              placeholder={"单选"}
              onChange={(data) => {
                if (data !== undefined) onChange(data);
              }}
            >
              <div
                style={error ? { color: "red" } : {}}
                onClick={() => {
                  Toast.info("请单选" + mobileShowName, 1);
                }}
              >
                {mobileShowName}
              </div>
            </RadioItem>
          ) : description.inputType === 8 ? (
            <DictionarySelect
              key={description.fieldName}
              disabled={description.readOnly}
              dictionary={description.dictionary!}
              required={description.required}
              value={defaultValue?.split(",")}
              placeholder={"多选"}
              onChange={(data) => {
                console.log(data);
                if (data !== undefined) onChange(data);
              }}
            >
              <div
                className="table-grid-item-title"
                style={error ? { color: "red" } : {}}
                onClick={() => {
                  Toast.info("请多选" + mobileShowName, 1);
                }}
              >
                {mobileShowName}
              </div>
            </DictionarySelect>
          ) : description.inputType === 9 ? (
            <ImageItem
              key={description.fieldName}
              disabled={description.readOnly}
              dictionary={description.dictionary!}
              value={defaultValue?.split(",")}
              placeholder={"照片"}
              width={"400px"}
              onChange={(data) => {
                if (data !== undefined) onChange(data);
              }}
            />
          ) : description.inputType === 22 ? (
            <div className="table-grid-item-title">{mobileShowName}</div>
          ) : description.inputType === 11 ? (
            <div style={{ display: "flex" }}>
              <div className="table-grid-item-title">
                {description.required && (
                  <span className="adm-form-item-label-required">*</span>
                )}
                {mobileShowName}
              </div>
              {(defaultValue as string)
                .split(",")
                .filter((item) => item)
                .map((item) => (
                  <Image
                    onClick={() => {
                      setImageForm({
                        visible: true,
                        src: `${BaseURL}/oa/common/attachment/showImage?id=${item}`,
                      });
                    }}
                    alt="file"
                    style={{ height: 46 }}
                    src={`${BaseURL}/oa/common/attachment/showImage?id=${item}`}
                  />
                ))}
            </div>
          ) : description.inputType === 930 ? (
            <div className={"items-center"} style={{ display: "flex" }}>
              <div className="table-grid-item-title pt-0">
                {description.required && (
                  <span className="adm-form-item-label-required">*</span>
                )}
                {mobileShowName}
              </div>
              <TextareaItem
                onClick={() => {
                  setLoading(true);
                  navigator.geolocation.getCurrentPosition((position) => {
                    instance
                      .get<
                        Result<{
                          result: {
                            formatted_address: string;
                          };
                        }>
                      >(
                        `/oa/common/geodecoder?lon=${position.coords.longitude}&lat=${position.coords.latitude}`
                      )
                      .then((resp) => {
                        setLoading(false);
                        if (resp.data.Status === "1") {
                          onChange(resp.data.Data.result.formatted_address);
                        }
                      });
                  });
                }}
                key={description.fieldName}
                readOnly={true}
                placeholder={loading ? "定位中..." : "点击进行定位"}
                value={loading ? "定位中..." : defaultValue}
                style={{ fontSize: 15 }}
                className="border-bottom-d9"
                onChange={(data) => {
                  if (data !== undefined) onChange(data);
                }}
                autoHeight
              />
              <LocationOutline
                onClick={() => {
                  setLoading(true);
                  navigator.geolocation.getCurrentPosition(
                    (position) => {
                      instance
                        .get<
                          Result<{
                            result: {
                              formatted_address: string;
                            };
                          }>
                        >(
                          `/oa/common/geodecoder?lon=${position.coords.longitude}&lat=${position.coords.latitude}`
                        )
                        .then((resp) => {
                          setLoading(false);
                          if (resp.data.Status === "1") {
                            onChange(resp.data.Data.result.formatted_address);
                          }
                        });
                    },
                    function (positionError) {
                      alert(positionError.message);
                    }
                  );
                }}
              />
            </div>
          ) : (
            <div style={{ display: "flex" }}>
              <div className="table-grid-item-title">
                {description.required && (
                  <span className="adm-form-item-label-required">*</span>
                )}
                {mobileShowName}
              </div>
              <TextareaItem
                key={description.fieldName}
                disabled={description.readOnly}
                placeholder={"请填写" + mobileShowName}
                value={defaultValue}
                style={{ fontSize: 15 }}
                className="border-bottom-d9"
                onChange={(data) => {
                  if (data !== undefined) onChange(data);
                }}
                autoHeight
              />
            </div>
          )}
        </div>
        <ImageViewer
          image={imageForm.src}
          visible={imageForm.visible}
          onClose={() => {
            setImageForm({
              visible: false,
            });
          }}
        />
      </>
    );
  }
);
